export const contactoData = {
    ES: {
        titulos: {
            siguen: "FOLLOW US!"
        },
        // Ya no usamos array de telefonos:
        direccion: "West 12th Avenue, Vancouver, British Columbia, Canada, V5Y 1V4",
        telefono: "(236) 997-6291",
        email: " info@hrd.ltd",
        redesSociales: [
            {
                plataforma: "facebook",
                link: "https://www.facebook.com/Hisol.GranAltura",
                icono: "FaFacebookF"
            },
            {
                plataforma: "instagram",
                link: "https://www.instagram.com/hisol.ca?igsh=eXUzMHh5MnplZGxv",
                icono: "FaInstagram"
            },
            {
                plataforma: "youtube",
                link: "https://youtube.com/@hisol.granaltura?si=h6r8nv7yAnaQYusL",
                icono: "FaYoutube"
            },
            {
                plataforma: "tiktok",
                link: "https://www.tiktok.com/@hisol.ca?_t=ZS-8wKstOhAZgy&_r=1",
                icono: "FaTiktok"
            },
            {
                plataforma: "linkedin",
                link: "https://www.linkedin.com/company/hisol-mexico/",
                icono: "FaLinkedinIn"
            },
        ]
    }
};
